import gql from 'graphql-tag';
import placeFragment from '../fragments/place';

const GET_DEVICE_PLACE_BY_DEVICE = gql`
  query getDevicePlacesByDevice($deviceId: ID!) {
    getDevicePlacesByDevice(deviceId: $deviceId) {
      devicePlaces {
        id
        placeId
      }
    }
  }
`;

const GET_DEVICE_PLACE_BY_WORKSPACE = gql`
  query GetPlacesByWorkspace($workspaceId: ID!) {
    getPlacesByWorkspace(workspaceId: $workspaceId) {
      places {
        id
        street
        zipCode
        state
        city
        country {
          id
          name
        }
        countryId
        name
        workspaceId
        coordinate
        devices {
          id
          workspacePrefixId
          workspacePrefix {
            id
            prefix
          }
          name
          uniqueId
        }
      }
    }
  }
`;

const GET_PLACE_BY_ID = gql`
  query getPlaceById($getPlaceById: ID!) {
    getPlaceById(id: $getPlaceById) {
      ...placeDetails
    }
  }
  ${placeFragment.FRAGMENT_PLACE}
`;

export default {
  GET_DEVICE_PLACE_BY_DEVICE,
  GET_PLACE_BY_ID,
  GET_DEVICE_PLACE_BY_WORKSPACE,
};
